import { AnyAction } from 'redux';
import {
    GET_VISITOR_LIST_REQUEST,
    GET_VISITOR_LIST_SUCCESS,
    GET_VISITOR_LIST_FAILURE,
    GET_VISITOR_LIST_BY_ID_REQUEST,
    GET_VISITOR_LIST_BY_ID_SUCCESS,
    GET_VISITOR_LIST_BY_ID_FAILURE,
    CREATE_VISITOR_FAILURE,
    CREATE_VISITOR_REQUEST,
    CREATE_VISITOR_SUCCESS,
    CLEAR_VISITOR_DATA,
    EDIT_VISITOR_FAILURE,
    EDIT_VISITOR_REQUEST,
    EDIT_VISITOR_SUCCESS,
} from '../constants/visitor-list.constants';

const initialState = {
    loading: false,
    data: [],
    error: '',
    createdVisitor: {
        loading: false,
        data: [],
        error: '',
    },
    editVisitor: {
        loading: false,
        data: [],
        error: '',
    },
};

export const visitorListReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_VISITOR_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                error: '',
            };

        case GET_VISITOR_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_VISITOR_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case GET_VISITOR_LIST_BY_ID_REQUEST:
            return {
                ...state,
                loading: true,
            };

        case GET_VISITOR_LIST_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: '',
            };
        case GET_VISITOR_LIST_BY_ID_FAILURE:
            return {
                ...state,
                loading: false,
                data: [],
                error: action.payload,
            };
        case CREATE_VISITOR_REQUEST:
            return {
                ...state,
                createdVisitor: {
                    ...state.createdVisitor,
                    loading: true,
                    error: '',
                    data: [],
                },
            };
        case CREATE_VISITOR_SUCCESS:
            return {
                ...state,
                createdVisitor: {
                    ...state.createdVisitor,
                    loading: false,
                    data: action.payload,
                },
            };
        case CREATE_VISITOR_FAILURE:
            return {
                ...state,
                createdVisitor: {
                    ...state.createdVisitor,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case EDIT_VISITOR_REQUEST:
            return {
                ...state,
                editVisitor: {
                    ...state.editVisitor,
                    loading: true,
                    error: '',
                },
            };
        case EDIT_VISITOR_SUCCESS:
            return {
                ...state,
                editVisitor: {
                    ...state.editVisitor,
                    loading: false,
                    data: action.payload,
                },
            };
        case EDIT_VISITOR_FAILURE:
            return {
                ...state,
                editVisitor: {
                    ...state.editVisitor,
                    loading: false,
                    data: [],
                    error: action.payload,
                },
            };
        case CLEAR_VISITOR_DATA:
            return {
                ...state,
                loading: false,
                data: [],
                error: '',
                createdVisitor: {
                    ...state.createdVisitor,
                    loading: false,
                    data: [],
                    error: '',
                },
                editVisitor: {
                    ...state.createdVisitor,
                    loading: false,
                    data: [],
                    error: '',
                },
            };
        default:
            return state;
    }
};
